import React, { Component } from "react";

import PropTypes from "prop-types";
import classnames from "classnames";
import CarouselItem from "./CarouselItem";

import "./Carousel.scss";

class Carousel extends Component {
	state = {
		selectedIndicator: 0,
		deltaX: 0,
		startingX: 0,
	}

	get shouldShowIndicator() {
		return this.carouselItemCount > 1;
	}

	get carouselItemCount() {
		const {
			children,
		} = this.props;

		return React.Children.count(children);
	}

	isSelectedIndicator(index) {
		const {
			selectedIndicator,
		} = this.state;

		return selectedIndicator === index;
	}

	indicatorClick = (index) => () => {
		this.setState({
			selectedIndicator: index,
		});
	}

	_getCoord = (e) => {
		return e.touches ? e.touches[0].pageX : e.pageX;
	};

	_getNewIndex = (position, direction) => {
		// if we're going backwards, go to the previous item;
		// otherwise, show the next item
		const index = direction < 0 ? position - 1 : position + 1;
		const maxIndex = this.carouselItemCount - 1;

		if (index < 0) {
			return 0;
		} else if (index > maxIndex) {
			return maxIndex;
		} else {
			return index;
		}
	};

	_onTouchStart = (e) => {
		e.preventDefault();
		const startingX = this._getCoord(e);

		this.setState({ startingX });
	}

	_onTouchMove = (e) => {
		e.preventDefault();
		const { startingX } = this.state;
		const currentX = this._getCoord(e);

		this.setState({ deltaX: startingX - currentX });
	}

	_onTouchEnd = (e) => {
		e.preventDefault();

		const selectedIndicator = this._getNewIndex(this.state.selectedIndicator, this.state.deltaX);

		this.setState({
			deltaX: 0,
			selectedIndicator,
		});
	}

	render() {
		const {
			children,
		} = this.props;

		return (
			<div
				className={classnames({
					"payment-carousel": true,
				})}
			>
				<div
					className={classnames({
						"payment-carousel-item-container": true,
					})}
					style={{
						width: `${100 * this.carouselItemCount}%`,
						left: `-${100 * this.state.selectedIndicator}%`,
					}}
					onTouchStart={this._onTouchStart}
					onTouchMove={this._onTouchMove}
					onTouchEnd={this._onTouchEnd}
				>
					{children}
				</div>

				<div
					className={classnames({
						"payment-carousel-indicator-container": true,
					})}
				>
					{this.shouldShowIndicator && children.map((child, index) => (
						<button
							onClick={this.indicatorClick(index)}
							key={child.props.index}
							className={classnames({
								"payment-carousel-indicator": true,
								"payment-carousel-indicator--selected": this.isSelectedIndicator(index),
							})}
						/>
					))}
				</div>
			</div>
		);
	}
}

Carousel.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Carousel;
export {
	CarouselItem,
};



// WEBPACK FOOTER //
// ./src/apps/payment/components/Carousel/index.jsx